export function focusRef(ref, delay = 0) {
  setTimeout(() => {
    if (ref && ref.scrollIntoView) {
      ref.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, delay);
}
